import { AuthenticationResult, EventType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import router from '@/router';
import { store } from '@/plugins/store';
import { MENU } from '@/components/layout/store/mutation-types';

const savedPolicy = localStorage.getItem('activeB2cPolicy');

const msalConfig = {
    auth: {
        authority: window.CONFIG.auth.authority + '/' + (savedPolicy || '') + '/',
        clientId: window.CONFIG.auth.clientId,
        knownAuthorities: window.CONFIG.auth.knownAuthorities,
        redirectUri: window.CONFIG.auth.redirectUriWeb,
        postLogoutRedirectUri: window.CONFIG.auth.postLogoutRedirectUriWeb,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage', // Options are localStorage, sessionStorage, memoryStorage
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Error,
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Trace:
                        console.debug(message);
                        return;
                }
            },
            allowRedirectInIframe: true,
            piiLoggingEnabled: false,
        },
    },
};

export let msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
configurationInstanceMSAL();

export async function useMsalInstance(b2cPolicy: string): Promise<void> {
    if (!b2cPolicy) {
        console.warn('[MSAL] Politique B2C absente.');
        return;
    }

    localStorage.setItem('activeB2cPolicy', b2cPolicy);

    msalConfig.auth.authority = window.CONFIG.auth.authority + '/' + b2cPolicy + '/';
    msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
    configurationInstanceMSAL();
}

function configurationInstanceMSAL() {
    // On ajoute un callback pour écouter quand la personne s'authentifie
    msalInstance.addEventCallback(async (event: any) => {
        console.info('[authConfig] EVENT init= ' + event);
        if (!event.payload) {
            return;
        }

        console.info('[authConfig] EVENT = ' + event.eventType);

        // WEB : connexion silencieuse = ACQUIRE_TOKEN_SUCCESS | connexion via page Microsoft = LOGIN_SUCCESS
        if (
            !store.getters['authenticationState/isAcquiringToken'] &&
            (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)
        ) {
            // On set le compte connecté
            const authResult: AuthenticationResult = event.payload as AuthenticationResult;
            localStorage.setItem('token_azure', authResult.idToken);
            msalInstance.setActiveAccount(authResult.account);

            // On va sur la première page de l'application (parmi celles qui nécessitent d'être authentifiées)
            const previousRoute = localStorage.getItem('previousRoute') || '';
            const nextRoute = localStorage.getItem('nextRoute') || '';
            if (previousRoute === '/' || previousRoute === '') {
                if (localStorage.getItem('isFournisseur') === 'true' && localStorage.getItem('isClient') !== 'true') {
                    store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'fournisseur');
                    router.push({ path: '/dashboard-fournisseur' });
                } else {
                    if (
                        (localStorage.getItem('isFournisseur') == null && localStorage.getItem('isClient') == null) ||
                        localStorage.getItem('isFournisseur') === 'true'
                    ) {
                        store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, undefined);
                    } else {
                        store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'client');
                    }
                    router.push({ path: '/dashboard' });
                }
            } else {
                router.push({ path: nextRoute });
            }
        }
    });
}

export const loginRequest = {
    scopes: [window.CONFIG.auth.scope],
};
